import React from 'react'
import { Box, Grid, Container, Typography } from '@mui/material'
import Map2Form from '../components/map2/Map2Form'
import Map2GoogleMap from '../components/map2/Map2GoogleMap'
import Map2Legend from '../components/map2/Map2Legend'
import { useSelector } from 'react-redux'
import { RootState } from '../store'

const Map2Page: React.FC = () => {
  const { submitted } = useSelector((state: RootState) => state.map2)

  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Map2Form />
            <Map2Legend />
          </Grid>
          <Grid item xs={12} md={8}>
            <Map2GoogleMap />
          </Grid>
        </Grid>
      </Box>
    </Container>
  )
}

export default Map2Page 